import * as React from 'react';

import { Button } from '@coursera/cds-core';

import { PATHS } from 'bundles/degree-home/components/v3-dpm/constants/constants';
import { VIEW_PROGRESS_DETAILS_BUTTON } from 'bundles/degree-home/components/v3-dpm/constants/trackingNameConstants';
import type { TrackingProps } from 'bundles/page/components/TrackedLink2';
import { TrackedLink2 } from 'bundles/page/components/TrackedLink2';

import _t from 'i18n!nls/degree-home';

const ViewProgressButton = () => {
  return (
    <Button
      trackingName={VIEW_PROGRESS_DETAILS_BUTTON}
      withVisibilityTracking
      component={(props: TrackingProps) => <TrackedLink2 {...props} href={`./${PATHS.ACADEMICS}`} />}
      size="small"
      variant="secondary"
      aria-label={_t('View progress details')}
    >
      {_t('View progress details')}
    </Button>
  );
};

export default ViewProgressButton;
